// extracted by mini-css-extract-plugin
export default {"AppointmentForm":"NewPwdForm_AppointmentForm__LjiOJ"};